/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.input-wrapper[_ngcontent-%COMP%]{flex-basis:100%;max-width:100%}}@media screen and (min-width:600px){.form[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}.input-wrapper[_ngcontent-%COMP%]{flex-basis:50%;max-width:50%}.input-wrapper[_ngcontent-%COMP%]:nth-of-type(odd){padding-right:12px}.input-wrapper[_ngcontent-%COMP%]:nth-of-type(even){padding-left:12px}}"];
export { styles as styles };
